import { GridColDef } from "@mui/x-data-grid-pro";
import {
  DeleteIcon,
  GKButton,
  GKClientDataGrid,
  IconButton,
  PlusIcon,
  PopConfirm,
  StatusField,
  Typography,
} from "components";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import { useState } from "react";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField, matchDate, refetchQuery } from "utils/helpers";
import TelegramModal from "./TelegramModal";

const TelegramTab = () => {
  const [openModal, setOpenModal] = useState(false);

  const [editData, setEditData] = useState<any>(null);

  const [confirmationModal, setConfirmationModal] =
    useState<HTMLElement | null>(null);
  const [selectedTelegramId, setSelectedTelegramId] = useState<string | null>(
    null,
  );

  const { id } = useParams<{ id: string }>();

  const { data } = useFetchQuery({
    key: ["TELEGRAM_CHANNELS", id],
    route: `/telegram-channels/?basket=${id}`,
  });

  const { mutate: deleteTelegram } = useMutation({
    mutationFn: (telegramId: string) =>
      axiosInstance.delete(`/telegram-channels/${telegramId}`),
    onSuccess: (response) => {
      toast.success(response.data?.message || "Telegram channel deleted!");
      refetchQuery("TELEGRAM_CHANNELS");
      setConfirmationModal(null);
      setSelectedTelegramId(null);
    },
    onError: (error: any) => {
      toast.error(
        error.response?.data?.message || "Failed to delete Telegram channel",
      );
      setConfirmationModal(null);
      setSelectedTelegramId(null);
    },
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Channel Name", "channelName", 120, 1),
    },
    {
      ...extraColumnsField("Channel Id", "channelId", 120, 1),
    },
    {
      ...extraColumnsField("Status", "isActive", 120, 1),
      renderCell: (params) => (
        <StatusField
          statusString={params.row.isActive ? "approved" : "pending"}
        />
      ),
    },
    {
      ...extraColumnsField("Created", "createdAt", 120, 1),
      renderCell: (value) => (
        <Typography>{matchDate(value.row.createdAt) || "N/A"}</Typography>
      ),
    },
    {
      ...extraColumnsField("Action", "action", 0, 1),
      align: "right",
      headerAlign: "right",
      renderCell: (params) => (
        <IconButton
          color="error"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmationModal(e.currentTarget);
            setSelectedTelegramId(params.row.id);
          }}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <>
      <GKClientDataGrid
        maxHeight={"295px"}
        columns={columns}
        rows={data?.data?.data || []}
        name="telegramTab"
        onRowClick={(params) => {
          setEditData(params.row);
          setOpenModal(true);
        }}
        headerComponent={
          <GKButton
            variant="contained"
            startIcon={<PlusIcon />}
            onClick={() => {
              setEditData(null);
              setOpenModal(true);
            }}
          >
            Setup
          </GKButton>
        }
      />

      {openModal && (
        <TelegramModal
          open={openModal}
          setOpen={setOpenModal}
          editData={editData}
          telegramId={editData?.id}
        />
      )}

      {confirmationModal && selectedTelegramId && (
        <PopConfirm
          anchorEl={confirmationModal}
          open={Boolean(confirmationModal)}
          setOpen={setConfirmationModal}
          onSuccess={() => deleteTelegram(selectedTelegramId)}
        />
      )}
    </>
  );
};

export default TelegramTab;
